import ConfiguratorTemplate from '../ConfiguratorTemplate';
import EighthInchDropdown from './Component';

export default ConfiguratorTemplate(EighthInchDropdown);
